import { createContext, useContext } from 'react';

export const CampaignContext = createContext();

export const useCampaignContext = () => useContext(CampaignContext);
